import "../../App.css";
import React, { lazy, Suspense, useEffect } from "react";
import Sidebar from "../../Module/sidebar";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import Loading from "../../Component/Loading";
import {
  TeacherEmpPanelSidebarData,
  TeacherPanelSidebarData,
} from "../../Module/teacherPanelSidebarData";
import PdfViewer from "../../Component/pdfViewer";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { showSuccessSnackbar } from "../../Action/snackbarAction";
import { Logout, setInitialState } from "../../Action/authAction";
import CommonRoutes from "../Common/commonRoute";
import ScholarshipExamResult from "../SalesUpsellingPanel/scholarshipExamResult";

const Dashboard = React.lazy(() => import("./dashboard"));
const UploadLiveVideo = React.lazy(() => import("./uploadLiveVideo"));
const UploadLivePDF = React.lazy(() => import("./uploadLivePDF"));
const UploadRecordedVideo = React.lazy(() => import("./uploadRecordedVideo"));
const UpcomingLiveSchedule = React.lazy(() => import("./upcomingLiveSchedule"));
const CourseSupport = React.lazy(() => import("./courseSupport"));
const Helpdesk = React.lazy(() => import("./helpdesk"));
const WorkHoursDetails = React.lazy(() => import("./workHoursDetails"));
const Chat = React.lazy(() => import("./chat"));
const Issue = React.lazy(() => import("./issue"));
const Feedback = React.lazy(() => import("./feedback"));
const LectureFeedback = React.lazy(() => import("./lectureFeedback"));
const TeacherTaskPlan = React.lazy(() => import("./teacherTaskPlan"));
const PptForPenDisplay = React.lazy(() => import("./pptForPenDisplay"));
const PptForSmartBoard = React.lazy(() => import("./pptForSmartBoard"));
const TeacherSOP = React.lazy(() => import("./teacherSOP"));
const Syllabus = React.lazy(() => import("./syllabusDashboard"));
const Question = React.lazy(() => import("./editDeleteQuestionBank"));
const AddTeacherYTData = React.lazy(() => import("./addTeacherYoutubeData"));
const EditTeacherYTData = React.lazy(() => import("./editTeacherYoutubeData"));
const LectureDelayed = React.lazy(() => import("./lectureDelayed"));
const QuestionDoubtList = React.lazy(() => import("./questionDoubtList"));
const StudentAnalysisDashboard = React.lazy(() =>
  import("./StudentAnalysis/studentAnalysisDashboard")
);
const SundayTestAnalysisDashboard = React.lazy(() =>
  import("./SundayTestAnalysis/sundayTestAnalysisDashboard")
);
const StudentBatchWiseResult = React.lazy(() =>
  import("./studentBatchWiseResultDashboard")
);
const UploadTestDiscussionVideo = React.lazy(() =>
  import("./uploadTestDiscussionVideo")
);
const AddQuestionPoll = React.lazy(() =>
  import("./QuestionPoll/addQuestionPoll")
);
const EditQuestionPoll = React.lazy(() =>
  import("./QuestionPoll/editQuestionPoll")
);
const MovementsOfMeeting = React.lazy(() =>
  import("../CategoryPanel/MovementsOfMeeting/movementsOfMeeting")
);
const EditMovementsOfMeeting = React.lazy(() =>
  import("../CategoryPanel/MovementsOfMeeting/editMovementsOfMeeting")
);
const TeacherTotalRevenue = lazy(() => import("./totalRevenueTeacher"));
const TeacherPerformance = lazy(() => import("../CXOPanel/teacherPerformance"));
// import JitSiConference from "./JitSiConference";

function TeacherPanelDashboard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loginType, role, authToken } = useSelector((state) => ({
    designation: state.Auth?.userInfo?.designation,
    loginType: state.Auth?.loginType,
    role: state?.Auth?.userInfo?.role,
    authToken: state?.Auth?.authToken,
  }));
  const RevenueAnalysis = React.lazy(() => import("./revenueAnalysis"));

  useEffect(() => {
    if (!(role === "TEACHER" && authToken)) {
      dispatch(setInitialState());
      navigate("/");
    }
  }, [role, dispatch, Navigate, authToken]);
  return (
    <div className="AppBox">
      {/* <Header /> */}
      <Sidebar
        data={
          loginType === 2 ? TeacherEmpPanelSidebarData : TeacherPanelSidebarData
        }
      />
      <div className="dashboard">
        {
          <Suspense
            fallback={
              <div className="border p-1">
                <Loading />
              </div>
            }
          >
            <CommonRoutes
              loginType={loginType}
              defaultPage={<Dashboard />}
              role={role}
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route
                path="upcomingLiveSchedule"
                element={<UpcomingLiveSchedule />}
              />
              <Route path="uploadLiveVideo" element={<UploadLiveVideo />} />
              <Route path="uploadLivePDF" element={<UploadLivePDF />} />
              <Route
                path="uploadRecordedVideo"
                element={<UploadRecordedVideo />}
              />
              <Route path="CourseSupport" element={<CourseSupport />} />
              <Route path="helpdesk" element={<Helpdesk />} />
              <Route path="workHoursDetails" element={<WorkHoursDetails />} />
              <Route path="Chat" element={<Chat />} />
              <Route path="issue" element={<Issue />} />
              <Route path="feedback" element={<Feedback />} />
              <Route path="lectureFeedback" element={<LectureFeedback />} />
              <Route path="teacherTaskPlan" element={<TeacherTaskPlan />} />
              <Route path="pptForPenDisplay" element={<PptForPenDisplay />} />
              <Route path="pptForSmartBoard" element={<PptForSmartBoard />} />
              <Route path="teacherSOP" element={<TeacherSOP />} />
              <Route path="PdfViewer" element={<PdfViewer />} />
              <Route path="PdfViewer" element={<PdfViewer />} />
              <Route path="syllabusDashboard" element={<Syllabus />} />
              <Route path="question" element={<Question />} />
              <Route path="addTeacherYTData" element={<AddTeacherYTData />} />
              <Route path="editTeacherYTData" element={<EditTeacherYTData />} />
              <Route path="lectureDelayed" element={<LectureDelayed />} />
              <Route path="questionDoubtList" element={<QuestionDoubtList />} />
              <Route
                path="studentAnalysisDashboard"
                element={<StudentAnalysisDashboard />}
              />
              <Route
                path="sundayTestAnalysisDashboard"
                element={<SundayTestAnalysisDashboard />}
              />
              <Route
                path="studentBatchWiseResultDashboard"
                element={<StudentBatchWiseResult />}
              />
              <Route
                path="uploadTestDiscussionVideo"
                element={<UploadTestDiscussionVideo />}
              />
              <Route path="addQuestionPoll" element={<AddQuestionPoll />} />
              <Route path="editQuestionPoll" element={<EditQuestionPoll />} />
              <Route
                path="movementsOfMeeting"
                element={<MovementsOfMeeting />}
              />
              <Route
                path="editMovementsOfMeeting"
                element={<EditMovementsOfMeeting />}
              />
              <Route
                path="totalRevenueTeacher"
                element={<TeacherTotalRevenue />}
              />
              <Route path="revenueAnalysis" element={<RevenueAnalysis />} />
              <Route
                path="ScholarshipExamResult"
                element={<ScholarshipExamResult />}
              />
              <Route
                path="teacherPerformance"
                element={<TeacherPerformance />}
              />
              {/* <Route path="JitSiConference" element={<JitSiConference />} /> */}
            </CommonRoutes>
          </Suspense>
        }
      </div>
    </div>
  );
}

export default TeacherPanelDashboard;
